import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { Context } from "states/Store";
import { getUserRoles } from "services/edge/UserService";
import { useAuth } from "@ea-webapp/auth";
import { ERROR, UNAUTHORIZED_PAGE } from "services/common/Constants";
import { getCurrentUserSigRoles } from '../../../services/edge/UserSigService';
import { RoleBasedAccessControlContext } from "services/common/RolesUtils";

export function useRoles() {
  const [state, dispatch] = useContext(Context);
  const { authState } = useAuth();
  const { isSigUser } = useContext(RoleBasedAccessControlContext);

  const history = useHistory();
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    async function getAllUserRoles() {
      try {
        let results = null;
        let roles = [];

        if (!state.isSuperAdminUser) {
          if(isSigUser) {
            results = await getCurrentUserSigRoles(dispatch);
          } else {
            results = await getUserRoles(state.account.id, authState.user.id, false, true, true, dispatch);
          }

          if (results?.content) {
            roles = results.content;

            if (_.isEmpty(roles)) {
              if (authState?.user?.idp) {
                history.push("/" + UNAUTHORIZED_PAGE + "?ssoMode=true");
              } else {
                history.push("/" + UNAUTHORIZED_PAGE);
              }
            }
          }
        setUserRoles(roles);
        dispatch({ type: "USER_ROLES", roles: roles});
        }
      } catch (e) {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "INTERNAL_ERROR" },
        });
      }
    }

    if (authState.user && state.account) {
      getAllUserRoles();
    }
  }, [state.account, authState.user, isSigUser, history, dispatch, state.isSuperAdminUser]);

  return userRoles;
}
